var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isMobile
        ? _c("v-data-table", {
            staticClass: "standard-table pripoistenie",
            attrs: {
              headers: _vm.getHeaders,
              items: _vm.categories,
              "hide-default-footer": "",
              "disable-sort": ""
            },
            on: {
              "page-count": function($event) {
                _vm.pageCount = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.display",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "span",
                        {
                          class: item.required ? "text-required" : "",
                          staticStyle: {
                            "font-size": "16px",
                            "font-weight": "700"
                          }
                        },
                        [_vm._v(" " + _vm._s(item.display) + " ")]
                      )
                    ]
                  }
                },
                {
                  key: "item.children",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("v-autocomplete", {
                        key: item.combo_key,
                        staticClass:
                          "dynamic-input-control error--text--top-14",
                        class: {
                          required: item.required,
                          readonly: item.readonly
                        },
                        attrs: {
                          items: item.children,
                          placeholder: "",
                          label: "Zvoľte typ",
                          outlined: "",
                          "hide-details": "",
                          "item-text": "displayMember",
                          "item-value": "valueMember",
                          clearable: "",
                          "error-messages":
                            !item.isValidate && item.isDirty
                              ? "Toto pole je povinné!"
                              : "",
                          disabled: item.readonly,
                          readonly: item.readonly
                        },
                        on: {
                          change: function($event) {
                            return _vm.update(item)
                          }
                        },
                        model: {
                          value: item.value,
                          callback: function($$v) {
                            _vm.$set(item, "value", $$v)
                          },
                          expression: "item.value"
                        }
                      })
                    ]
                  }
                },
                {
                  key: "item.price",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v(_vm._s(item.price ? item.price : null))
                      ])
                    ]
                  }
                },
                {
                  key: "footer",
                  fn: function() {
                    return [_c("v-divider")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        : _vm._l(_vm.categories, function(item, index) {
            return _c(
              "div",
              { key: item.valueMember },
              [
                _c(
                  "v-row",
                  { staticStyle: { "font-size": "16px" } },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "text-required",
                        staticStyle: { "font-weight": "700" },
                        attrs: { cols: "7" }
                      },
                      [_vm._v(" " + _vm._s(item.display) + " ")]
                    ),
                    !_vm.jeOlfs
                      ? _c(
                          "v-col",
                          {
                            staticStyle: { "text-align": "right" },
                            attrs: { cols: "5" }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(item.price ? item.price : null) + " "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c("v-autocomplete", {
                  key: item.combo_key,
                  staticClass: "dynamic-input-control error--text--top-14",
                  class: {
                    required: item.required,
                    readonly: item.readonly
                  },
                  attrs: {
                    items: item.children,
                    placeholder: "",
                    label: "Zvoľte typ",
                    outlined: "",
                    "hide-details": "",
                    "item-text": "displayMember",
                    "item-value": "valueMember",
                    clearable: "",
                    "error-messages":
                      !item.isValidate && item.isDirty
                        ? "Toto pole je povinné!"
                        : "",
                    disabled: item.readonly,
                    readonly: item.readonly
                  },
                  on: {
                    change: function($event) {
                      return _vm.update(item)
                    }
                  },
                  model: {
                    value: item.value,
                    callback: function($$v) {
                      _vm.$set(item, "value", $$v)
                    },
                    expression: "item.value"
                  }
                }),
                index != [_vm.categories.length - 1]
                  ? _c("v-row", { staticClass: "mt-3" }, [_c("v-divider")], 1)
                  : _vm._e()
              ],
              1
            )
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }